// A page the customer must finish on another site — a bank's 3-D Secure check, a Stripe
// checkout — used to be opened straight from the saga with window.open(_blank). That call
// runs after the network round-trip, outside any user gesture, so every browser with a
// pop-up blocker silently swallowed it and the customer saw "Pop-up Blocked" (WBA-3926).
//
// The saga now only announces the link; ExternalLinkGate (mounted once in App) shows what is
// about to happen and opens the tab from the customer's own click, which no blocker stops.
type Listener = (url: string) => void

const listeners = new Set<Listener>()

export const requestExternalLink = (url: string) => {
  listeners.forEach((listener) => listener(url))
}

export const subscribeExternalLink = (listener: Listener) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
